export enum DeviceType {
  Mobile = "mobile",
  Desktop = "desktop",
}

/** Coarse phone/pc classification for funnel telemetry. */
export const getDeviceType = (): DeviceType => {
  const uaMobile = (
    navigator as Navigator & { userAgentData?: { mobile?: boolean } }
  ).userAgentData?.mobile;
  if (typeof uaMobile === "boolean") {
    return uaMobile ? DeviceType.Mobile : DeviceType.Desktop;
  }
  // Good enough for phone/pc; add a UA-parse lib only if tablet/other buckets
  // are ever needed.
  return window.matchMedia("(pointer: coarse)").matches
    ? DeviceType.Mobile
    : DeviceType.Desktop;
};
